import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  storePurchaseData: null,
};

export const getStorePurchase = createAsyncThunk(
  "storePurchase/getStorePurchase",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`store-purchase`, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const storePurchaseSlice = createSlice({
  name: "storePurchase",
  initialState,
  reducers: {},
  extraReducers: {
    [getStorePurchase.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getStorePurchase.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.storePurchaseData = action.payload?.data;
    },
    [getStorePurchase.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default storePurchaseSlice.reducer;
